import TagIcon from "@uui/Tag01";

import HeaderButton from "@app/analytics/components/reports/HeaderButton";
import ManageTagsPopover from "@app/analytics/components/TagPopover/ManageTagsPopover";
import { UseManageTagsArgs } from "@app/analytics/components/TagPopover/useManageTags";
import { toast } from "@app/common/hooks/useToasts";

import type { ManageTagsProps } from "./types";

const ManageReportTagsButtonAndPopover = ({
  disabled,
  onSave,
  ...popoverProps
}: ManageTagsProps) => {
  const handleSave: UseManageTagsArgs["onSave"] = (
    updatedTags,
    applyToSeries
  ) => {
    onSave.mutate(
      { updatedTags, applyToSeries },
      {
        onError: () =>
          toast.error(
            "Oops! Something went wrong and one or more of your tags could not be saved."
          ),
      }
    );
  };

  return (
    <ManageTagsPopover
      {...popoverProps}
      onSave={handleSave}
      renderControl={({ onClick }) => (
        <HeaderButton
          className="meeting-report__header__tags"
          startIcon={<TagIcon />}
          onClick={onClick}
          disabled={disabled}
        >
          Tags ({popoverProps.appliedTags.length})
        </HeaderButton>
      )}
    />
  );
};

export default ManageReportTagsButtonAndPopover;
